import React, { Children } from 'react';
import { useViewportContext } from 'src/components/viewport/context';
import { useKWLPWidePageExperiment } from 'src/hooks/experiments';
import * as S from './styles';

type Props = {
  children?: React.ReactNode;
  className?: string;
  offers?: React.ReactNode[] | null;
  isWide?: boolean;
  isOffers?: boolean;
  smallerProductCardsMobileExperiment?: boolean;
};

export const OffersGrid = ({
  children,
  className,
  offers,
  isWide,
  isOffers,
  smallerProductCardsMobileExperiment = false,
}: Props) => {
  const { isMobile } = useViewportContext();
  const isExtraWide = useKWLPWidePageExperiment();

  return (
    <S.OffersGrid
      data-test={isOffers ? 'OfferGrid' : 'ProductGrid'}
      className={className}
      isWide={isWide}
      isExtraWide={isExtraWide}
      smallerProductCardsMobileExperiment={smallerProductCardsMobileExperiment}
    >
      {children}
      {offers &&
        Children.map(offers, (child, index) => (
          <S.OffersGridItem
            data-test={isOffers ? 'OfferGridCard' : 'ProductGridCard'}
            // smaller-product-cards-mobile-ui experiment relies on exactly this style property
            // Check with Jesper Engberg before changing
            style={{ order: index }}
          >
            {child}
          </S.OffersGridItem>
        ))}
      {offers &&
        isMobile &&
        smallerProductCardsMobileExperiment &&
        Children.map(
          // This fills up the remaining slots with empty grid items to cover the grey background
          Array(offers.length % S.ITEMS.small).fill(null),
          (_, index) => (
            <S.OffersGridItem style={{ order: offers.length + index }} />
          )
        )}
    </S.OffersGrid>
  );
};
